<script setup lang="ts">
import { signinUser } from "@/composables/auth";
import { getAndStore_UserAndCompany } from "@/composables/user";
import { initialPageRoute, router, routesName } from "@/plugins/router";
import loggerLocal from "@/utils/loggerLocal";
import { emailRule, passwordRule } from "@/utils/rules";
import { showErrorMessage } from "@/utils/showMessage";
import { DBRetCode } from "@functions/models/DBEnum";
import type { IntCredentials } from "@functions/models/interfaces/intCredentials";
import type { UserCredential } from "firebase/auth";
import { ref } from "vue";

/*Social icons*/
const { t } = useI18n();
const checkbox = ref(false);
const valid = ref(false);

const isLoading = ref(false);
const formToSubmit = ref();
const form = ref({
  email: "",
  password: "",
  remember: true,
});

async function signIn() {
  try {
    loggerLocal.info("start signin", valid.value, formToSubmit.value);
    const credentials: IntCredentials = {
      email: form.value.email,
      password: form.value.password,
      privacyPolicy: false,
    };
    isLoading.value = true;
    loggerLocal.info("Signing in with credentials:", credentials);
    //storeAuth.signIn(credentials);
    const signedIn = await signinUser(
      form.value.email,
      form.value.password,
      form.value.remember
    );
    loggerLocal.info("Signed in:", signedIn);
    if (signedIn) {
      //const check = await checkSession();
      const check = signedIn as UserCredential;
      if (check) {
        loggerLocal.debug("User signed in successfully:", check?.user?.uid, check);
        const resCall = await getAndStore_UserAndCompany(check?.user?.uid ?? undefined);
        loggerLocal.debug("User and company data retrieved:", resCall);
        if (resCall.result !== DBRetCode.SUCCESS) {
          loggerLocal.error("Error retrieving user and company data:", resCall);
          showErrorMessage(
            t("auth.errorRetrievingUserData", {
              error: resCall,
            })
          );
          // Handle error, e.g., show a notification
          // return;
        } else {
          router.push(initialPageRoute);
        }
      }
    }
  } catch (error) {
    loggerLocal.error("Error during sign in:", error);
    // Handle error, e.g., show a notification
  }
  isLoading.value = false;

  //console.log('signedIn', signedIn)
}
</script>

<template>
  <!--<v-row class="d-flex mb-3">
        <v-col cols="6" sm="6" class="pr-2">
            <v-btn variant="outlined" size="large"  class="border text-subtitle-1 hover-link-primary" block>
                <img :src="google" height="16" class="mr-2" alt="google" />
                Google
            </v-btn>
        </v-col>
        <v-col cols="6" sm="6" class="pl-2">
            <v-btn variant="outlined" size="large" class="border text-subtitle-1  hover-link-primary" block>
                <img :src="facebook" width="20" class="mr-1" alt="facebook" />
                Facebook
            </v-btn>
        </v-col>
    </v-row>
    <div class="d-flex align-center text-center mb-6">
        <div class="text-h6 w-100 px-5 font-weight-regular auth-divider position-relative">
            <span class="bg-surface px-5 py-3 position-relative">or sign in with</span>
        </div>  
    </div>-->
  <VForm ref="formToSubmit" v-model="valid" v-on:submit.prevent="signIn()" class="mt-5">
    <v-label class="font-weight-semibold pb-2">{{ t("auth.email") }}</v-label>
    <VTextField
      v-model="form.email"
      :rules="emailRule"
      class="mb-8"
      required
      hide-details="auto"
    ></VTextField>
    <v-label class="font-weight-semibold pb-2">{{ t("auth.password") }}</v-label>
    <VTextField
      v-model="form.password"
      :rules="passwordRule"
      required
      hide-details="auto"
      type="password"
      class="pwdInput"
    ></VTextField>
    <div class="d-flex flex-wrap align-center my-3 ml-n2">
      <v-checkbox class="pe-2" v-model="form.remember" hide-details color="primary">
        <template v-slot:label class="font-weight-medium">{{
          t("auth.rememberMe")
        }}</template>
      </v-checkbox>
      <div class="ml-sm-auto">
        <RouterLink
          :to="routesName.forgotPassword"
          class="text-primary text-decoration-none font-weight-medium"
          >{{ t("auth.forgotPassword") }}</RouterLink
        >
      </div>
    </div>
    <v-btn
      size="large"
      :loading="isLoading"
      color="primary"
      :disabled="!valid"
      block
      type="submit"
      flat
      >{{ t("auth.signin") }}</v-btn
    >
  </VForm>
</template>
